import type { PostHog } from 'posthog-js';

import type { TelemetryConsentState } from './telemetry-consent';

interface ApplyPosthogConsentOptions {
  purgeIdentity?: boolean;
}

export type PostHogConsentInterface = Pick<
  PostHog,
  | 'set_config'
  | 'opt_in_capturing'
  | 'stopSessionRecording'
  | 'opt_out_capturing'
  | 'reset'
  | 'startSessionRecording'
>;

export function applyPosthogConsent(
  posthog: PostHogConsentInterface | null | undefined,
  consentState: TelemetryConsentState,
  { purgeIdentity = false }: ApplyPosthogConsentOptions = {}
) {
  if (!posthog) return;

  const recordingsEnabled = consentState.analytics && consentState.recordings;

  posthog.set_config({
    autocapture: consentState.analytics,
    capture_pageview: false,
    capture_pageleave: consentState.analytics,
    disable_session_recording: !recordingsEnabled,
    persistence: consentState.analytics ? 'localStorage+cookie' : 'memory',
  });

  if (consentState.analytics) {
    posthog.opt_in_capturing();
  } else {
    posthog.stopSessionRecording();
    posthog.opt_out_capturing();

    if (purgeIdentity) {
      posthog.reset(true);
    }
  }

  if (recordingsEnabled) {
    posthog.startSessionRecording();
  } else {
    posthog.stopSessionRecording();
  }
}
